import React, { useState, useEffect, useContext } from "react";
import { Grid, Button, withStyles } from "@material-ui/core";
import UploadIcon from "@material-ui/icons/CloudUpload";
import SearchableSelect from "../../../../../../Component/Forms/SearchableSelect";
import { styles } from "./styles";
import RiskInfo from "./RiskInfo";
import { recordTypes } from "../../../../../../API/config";
import { getCountries, getCountryRiskData } from "../../../../../../API/Country";
import { httpPost } from "../../../../../../API/Http";
import ModalDialogContext from "../../../../../../Context/ModalDialog/ModalDialogContext";
import { useTranslation } from "react-i18next";

const CountryBasicTable = (props) => {
  const { classes, hasPermission } = props;
  const [countryList, setCountryList] = useState([]);
  const [countryId, setCountryId] = useState();
  const [countryRiskData, setCountryRiskData] = useState();
  const [uploadInputKey, setUploadInputKey] = useState(Date.now());

  const [canEdit, setCanEdit] = useState();
  const [canUpload, setCanUpload] = useState();

  const { showMessage, showErrorMessage, showLoadingMessage } = useContext(ModalDialogContext);
  const { t } = useTranslation();

  useEffect(() => {
    const evalPermissions = async () => {
      const canEdit = await hasPermission(
        recordTypes.countryRiskData.name,
        recordTypes.countryRiskData.actions.update.name
      );
      setCanEdit(canEdit);
      const canUpload = await hasPermission(
        recordTypes.countryRiskData.name,
        recordTypes.countryRiskData.actions.upload.name
      );
      setCanUpload(canUpload);
    };

    evalPermissions();
  }, []);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const result = await getCountries();
        const { data = [] } = result;
        setCountryList(data.map((val) => ({
          label: val.name,
          value: val.id,
        })));
      } catch (error) {
        showErrorMessage({
          error,
        });
      }
    };
    loadCountries();
  }, []);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const result = await getCountryRiskData(countryId);
        const { data = [] } = result;
        setCountryRiskData(data);
      } catch (error) {
        showErrorMessage({
          error,
        });
        setCountryRiskData(null);
      }
    };
    if (countryId) {
      loadCountries();
    }
  }, [countryId]);

  const uploadDocument = async (e) => {
    try {
      const formData = new FormData();
      formData.append("data", e.target.files[0]);

      showLoadingMessage({
        title: t("messages.country.riskDataUpload"),
        message: t("labels.common.uploading"),
      });

      await httpPost("/admin/countryRiskData", formData);
      showMessage({ message: t("messages.country.riskDatauploadSuccessful") });
    } catch (error) {
      showErrorMessage({
        error,
      });
    }
    setUploadInputKey(Date.now());
  };

  const countrySelect = async (country) => {
    setCountryId(country.value);
  };

  return (
    <>
      <Grid container spacing={2} justify="space-between" className={classes.container}>
        <Grid item xs={9}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <SearchableSelect
                options={countryList}
                changeHandler={countrySelect}
                placeholder={t("labels.country.countryRiskData.selectCountry")}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          {canUpload && <Grid container spacing={2} justify="center">
            <Grid item xs={3}>
              <input
                key={uploadInputKey}
                className={classes.hidden}
                id="upload-file"
                type="file"
                onChange={(e) => uploadDocument(e)}
              />
              <label htmlFor="upload-file">
                <Button
                  color="primary"
                  variant="contained"
                  style={{ height: 30, marginRight: 5 }}
                  component={"span"}
                >
                  <UploadIcon />
                </Button>
              </label>
            </Grid>
          </Grid>}
        </Grid>
      </Grid>
      {countryRiskData && <RiskInfo countryRiskData={countryRiskData} classes={classes} canEdit={canEdit} />}
    </>
  );
};

export default withStyles(styles, { withTheme: true })(CountryBasicTable);
